import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Footer from './components/Footer';
import ReservationModal from './components/ReservationModal';
import Rooms from './components/Rooms'; // Importar el nuevo componente
import Experiences from './components/Experiences'; // Importar el componente de experiencias
import Contact from './components/Contact'; // Importar el nuevo componente de contacto
import CTA from './components/CTA'; // Importar el nuevo componente CTA
import LoadingScreen from './components/LoadingScreen'; // Importar la pantalla de carga
import StickyReserveButton from './components/StickyReserveButton'; // Importar el botón flotante
import CookieBanner from './components/CookieBanner'; // Importar el banner de cookies
import Reviews from './components/Reviews';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminPrices from './pages/AdminPrices'; // Importar la nueva página de administración de precios
import AdminCalendar from './pages/AdminCalendar'; // Importar la nueva página de calendario
import AdminSettings from './pages/AdminSettings'; // Importar la nueva página de ajustes
import AdminQuotes from './pages/AdminQuotes'; // Importar página de cotizaciones
import AdminReviews from './pages/AdminReviews';
import TermsAndConditions from './pages/TermsAndConditions'; // Importar nueva página
import FAQ from './pages/FAQ'; // Importar nueva página de FAQ
import Sustainability from './pages/Sustainability'; // Importar nueva página de Sostenibilidad
import PrivacyPolicy from './pages/PrivacyPolicy'; // Importar página de Política de Privacidad

function App() {
  const [showReservationModal, setShowReservationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simula un tiempo de carga y luego oculta la pantalla de carga
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // 2.5 segundos

    return () => clearTimeout(timer);
  }, []);

  const HomePage = () => (
    <>
      <Navbar onReserveClick={() => setShowReservationModal(true)} />
      <Hero onReserveClick={() => setShowReservationModal(true)} />
      <About onReserveClick={() => setShowReservationModal(true)} />
      <Rooms onReserveClick={() => setShowReservationModal(true)} />
      <Experiences />
      <Reviews />
      <CTA onReserveClick={() => setShowReservationModal(true)} />
      <Contact />
      <Footer />

      <ReservationModal
        isOpen={showReservationModal}
        onClose={() => setShowReservationModal(false)}
      />
      <StickyReserveButton onReserveClick={() => setShowReservationModal(true)} />
    </>
  );

  return (
    <Router>
      <div className="App" style={{ overflowX: 'hidden' }}>
        <AnimatePresence>
          {isLoading && <LoadingScreen />}
        </AnimatePresence>
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/quotes" element={<AdminQuotes />} />
          <Route path="/admin/prices" element={<AdminPrices />} />
          <Route path="/admin/calendar" element={<AdminCalendar />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />
          <Route path="/preguntas-frecuentes" element={<FAQ />} />
          <Route path="/sostenibilidad" element={<Sustainability />} />
          <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
        </Routes>

        {/* Banner de cookies - se muestra en todas las páginas */}
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
